 const url={
    prod_api_auth_url:"https://8fhy9ntc6c.execute-api.ap-south-1.amazonaws.com/api/v1/voice_assistant/auth",
    prod_api_profile_url:"https://8fhy9ntc6c.execute-api.ap-south-1.amazonaws.com/api/v1/profile/own"
}

export  default url;